import React from "react";
import HandymanIcon from "@mui/icons-material/Handyman";
import { APP_STORE_LINK, PLAY_STORE_LINK } from "./MobileScreenWarning";

// Where a maintenance asset sticker's QR lands when the Rightwork app doesn't
// open it (no app installed, or an app version that doesn't handle the link
// yet). Static on purpose: no login, no lookup. The code printed on the
// sticker identifies the equipment, so this page asks for it on the ticket.
function AssetStickerPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm flex flex-col items-center text-center gap-6">
        <span className="w-[72px] h-[72px] rounded-[18px] bg-violet-700 flex items-center justify-center">
          <HandymanIcon sx={{ color: "white", fontSize: 36 }} />
        </span>
        <div className="flex flex-col gap-2.5">
          <h1 className="text-[22px] leading-snug font-bold text-slate-900">
            Report this in the Rightwork app
          </h1>
          <p className="text-[15px] leading-relaxed text-slate-600">
            This sticker is for reporting a problem with a piece of equipment. Open the Rightwork app, start a new
            maintenance ticket, and include the code printed on the sticker (like A-07).
          </p>
        </div>
        <div className="w-full flex flex-col gap-3">
          <a
            href={APP_STORE_LINK}
            className="h-[52px] rounded-xl bg-slate-900 text-white text-base font-semibold flex items-center justify-center"
          >
            Download on the App Store
          </a>
          <a
            href={PLAY_STORE_LINK}
            className="h-[52px] rounded-xl border border-slate-300 bg-white text-slate-900 text-base font-semibold flex items-center justify-center"
          >
            Get it on Google Play
          </a>
        </div>
      </div>
    </div>
  );
}

export default AssetStickerPage;
